import { useState } from "react";
import { Form, Input, Select, Button, Radio } from "antd";
import "./PonudjeniOdgovorStyle.css";
import "./EditPitanjeBeforeSave.css";
import "./AddNewPitanje.css";

const { TextArea } = Input;
const { Option } = Select;

function EditPitanjeBeforeSave({ pitanje, onSubmit }) {
  const [tekstPitanja, setTekstPitanja] = useState(pitanje.tekstPitanja || "");
  const [objasnjenje, setObjasnjenje] = useState(pitanje.objasnjenje || "");
  const [tip, setTip] = useState(pitanje.tip || "TEKSTUALNO");
  const [obavezno, setObavezno] = useState(pitanje.obavezno || false);
  const [pozicija, setPozicija] = useState(pitanje.pozicija || 1);
  const [odgovori, setOdgovori] = useState(pitanje.ponudjeniOdgovori || []);
  const [novaOpcija, setNovaOpcija] = useState("");
  const [answerConfirmIndex, setAnswerConfirmIndex] = useState(null);

  const handleSubmit = () => {
    const uredjenoPitanje = {
      ...pitanje,
      tekstPitanja,
      objasnjenje,
      tip,
      obavezno,
      pozicija,
      ponudjeniOdgovori: odgovori,
    };
    onSubmit(uredjenoPitanje);
  };
  const handleTipChange = (value) => {
    setTip(value);
    if (value === "DA_NE") {
      setOdgovori([
        { tekstOdgovora: "Da", pozicija: 1 },
        { tekstOdgovora: "Ne", pozicija: 2 },
      ]);
    } else if (value === "TEKSTUALNO") {
      setOdgovori([]);
    }
  };

  const handleOdgovorChange = (index, value) => {
    const newOdgovori = [...odgovori];
    newOdgovori[index].tekstOdgovora = value;
    setOdgovori(newOdgovori);
  };

  const handleAddOdgovor = () => {
    if (
      novaOpcija.trim() !== "" &&
      !odgovori.some((o) => o.tekstOdgovora === novaOpcija)
    ) {
      const noviOdgovor = {
        tekstOdgovora: novaOpcija,
        pozicija: odgovori.length + 1,
      };
      setOdgovori([...odgovori, noviOdgovor]);
      setNovaOpcija("");
    }
  };

  const handleRemoveOdgovor = (index) => {
    const newOdgovori = odgovori.filter((_, i) => i !== index);
    setOdgovori(newOdgovori.map((o, i) => ({ ...o, pozicija: i + 1 }))); // reindex
  };

  const handleMoveUp = (index) => {
    if (index === 0) return;
    const newOdgovori = [...odgovori];
    [newOdgovori[index - 1], newOdgovori[index]] = [
      newOdgovori[index],
      newOdgovori[index - 1],
    ];
    setOdgovori(newOdgovori.map((o, i) => ({ ...o, pozicija: i + 1 })));
  };

  const handleMoveDown = (index) => {
    if (index === odgovori.length - 1) return;
    const newOdgovori = [...odgovori];
    [newOdgovori[index], newOdgovori[index + 1]] = [
      newOdgovori[index + 1],
      newOdgovori[index],
    ];
    setOdgovori(newOdgovori.map((o, i) => ({ ...o, pozicija: i + 1 })));
  };

  return (
    <div className="edit-pitanje-card">
      <Form
        layout="horizontal"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        className="poll-form"
        style={{ marginTop: "20px" }}
      >
        <Form.Item label="Tekst pitanja" required>
          <TextArea
            className="textarea-field add-new-pitanje-input"
            value={tekstPitanja}
            onChange={(e) => setTekstPitanja(e.target.value)}
            placeholder="Unesite pitanje"
          />
        </Form.Item>

        <Form.Item label="Objašnjenje">
          <TextArea
            className="textarea-field add-new-pitanje-input"
            value={objasnjenje}
            onChange={(e) => setObjasnjenje(e.target.value)}
            placeholder="Unesite objašnjenje"
          />
        </Form.Item>

        <Form.Item label="Obavezno">
          <Radio.Group
            onChange={(e) => setObavezno(e.target.value === "Da")}
            value={obavezno ? "Da" : "Ne"}
          >
            <Radio value="Da">Da</Radio>
            <Radio value="Ne">Ne</Radio>
          </Radio.Group>
        </Form.Item>

        <Form.Item label="Tip pitanja" required>
          <Select
            value={tip}
            onChange={handleTipChange}
            className="select-field add-new-pitanje-select"
          >
            <Option value="TEKSTUALNO">Tekst</Option>
            <Option value="DA_NE">Da / Ne</Option>
            <Option value="VISESTRUKI_IZBOR">Višestruki izbor</Option>
            <Option value="JEDAN_IZBOR">Jednostruki izbor</Option>
          </Select>
        </Form.Item>

        {(tip === "VISESTRUKI_IZBOR" || tip === "JEDAN_IZBOR") && (
          <Form.Item labelCol={{ span: 0 }} wrapperCol={{ span: 24 }}>
            <div className="jedan-izbor-wrapper">
              <div className="odgovori-label">Ponuđeni odgovori:</div>
              <div className="novi-odgovori-container">
                {odgovori.map((odgovor, index) => (
                  <div key={index} className="odgovor-item">
                    <Input
                      value={odgovor.tekstOdgovora}
                      onChange={(e) =>
                        handleOdgovorChange(index, e.target.value)
                      }
                      className="input-field add-new-pitanje-input"
                    />
                    <div className="button-group">
                      <button
                        onClick={() => handleMoveUp(index)}
                        className="move-btn move-up"
                      >
                        ↑
                      </button>
                      <button
                        onClick={() => handleMoveDown(index)}
                        className="move-btn move-down"
                      >
                        ↓
                      </button>
                      <button
                        className="delete-button"
                        onClick={() =>
                          setAnswerConfirmIndex(
                            answerConfirmIndex === index ? null : index
                          )
                        }
                      >
                        ✖
                      </button>

                      {answerConfirmIndex === index && (
                        <div className="confirm-popup">
                          <p className="confirm-text">
                            Obrisati ponuđeni odgovor?
                          </p>
                          <div className="confirm-buttons">
                            <button
                              className="confirm-btn confirm-yes"
                              onClick={() => {
                                handleRemoveOdgovor(index);
                                setAnswerConfirmIndex(null);
                              }}
                            >
                              Da
                            </button>
                            <button
                              className="confirm-btn confirm-no"
                              onClick={() => setAnswerConfirmIndex(null)}
                            >
                              Ne
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
              <div className="input-container">
                <Input
                  className="input-field add-new-pitanje-input"
                  value={novaOpcija}
                  onChange={(e) => setNovaOpcija(e.target.value)}
                  placeholder="Unesite novu opciju"
                />
                <Button onClick={handleAddOdgovor} className="button-primary">
                  Dodaj opciju
                </Button>
              </div>
            </div>
          </Form.Item>
        )}
      </Form>

      <div style={{ textAlign: "center" }}>
        <Button
          type="primary"
          size="large"
          onClick={handleSubmit}
          className="button-primary"
        >
          Sačuvaj izmene
        </Button>
      </div>
    </div>
  );
}
export default EditPitanjeBeforeSave;
